import {useEffect, useState} from 'react'
import {isCheckInCheckOutAvailable} from 'components/Accommodation/Policies/utils'
import {MAXIMUM_POPULAR_FACILITIES} from 'components/Accommodation/PopularFacilities/constants'
import {GroupedFacilities} from 'types/Hotel'
import {
  facilityCategories,
  getGroupedFacilities,
  getHotelFacilitiesRanked,
  TOP_FACILITY_IDS
} from 'utils/facilities'

import {ContentHotel, TranslatedLOVItem} from '@findhotel/sapi'

export const useAccommodation = (hotel: ContentHotel) => {
  const [isCheckInCheckoutAvailable, setIsCheckInCheckoutAvailable] =
    useState(false)

  const [topFacilities, setTopFacilities] = useState<TranslatedLOVItem[]>([])
  const [hasPopularFacilitiesMore, setHasPopularFacilitiesMore] =
    useState(false)

  const [groupedFacilities, setGroupedFacilities] = useState<
    GroupedFacilities[]
  >([])

  const [hasPolicies, setHasPolicies] = useState(false)

  useEffect(() => {
    if (hotel) {
      const hasCheckInTimeCheckout = isCheckInCheckOutAvailable(hotel)
      setIsCheckInCheckoutAvailable(hasCheckInTimeCheckout)

      if (Array.isArray(hotel.facilities)) {
        setTopFacilities(
          getHotelFacilitiesRanked(
            hotel.facilities,
            TOP_FACILITY_IDS,
            MAXIMUM_POPULAR_FACILITIES
          )
        )
        setHasPopularFacilitiesMore(
          hotel.facilities.length > MAXIMUM_POPULAR_FACILITIES
        )

        setGroupedFacilities(
          getGroupedFacilities(hotel.facilities, facilityCategories)
        )
      }

      // This hotel has policies
      setHasPolicies(
        Boolean(hotel.checkInSpInst) ||
          Boolean(hotel.checkInMinAge) ||
          Boolean(hotel.deposit) ||
          Boolean(hotel.feesOpt) ||
          Boolean(hotel.checkInInst) ||
          Boolean(hotel.policies) ||
          hasCheckInTimeCheckout
      )
    }
  }, [hotel])

  return {
    isCheckInCheckoutAvailable,
    topFacilities,
    hasPopularFacilitiesMore,
    hasPopularFacilitiesSection: topFacilities.length > 0,
    groupedFacilities,
    hasFacilitiesSection: groupedFacilities.length > 0,
    hasPolicies
  }
}
